<template>
  <div class="w-full">
    <div id="fund-credit-card-card-number-input" class="w-full flex items-center card p-2">
      <div class="w-full" ref="card"></div>
    </div>
    <span class="text-danger text-sm block mt-2">{{ errors.first('card') }}</span>
  </div>
</template>

<script>
import LoadExternalScript from '../../../helpers/loadExternalScript'
import {cloneDeep, get} from 'lodash'

export default {
  data () {
    return {
      stripe: null,
      elements: null,
      card: null
    }
  },
  async mounted () {

    // load stripe SDK
    await LoadExternalScript('https://js.stripe.com/v3/')

    this.stripe = window.Stripe(window.speakol_configs.stripePublicKey)
    this.elements = this.stripe.elements()

    if (this.card === null) {
      this.card = await this.elements.create('card', {})

      this.card.on('change', (event) => {
        if (event.error) {
          this.$validator.errors.add({
            field: 'card',
            msg: event.error.message
          })
        } else {
          this.$validator.errors.remove('card')
        }
      })
    }

    await this.card.mount(this.$refs.card)


  },

  methods: {
    async confirmPayment (response) {
      const secretKey = response.data['secret_key']
      const result = cloneDeep(await this.stripe.confirmCardPayment(secretKey, {
        payment_method: {
          card: this.card
        }
      }))

      const status = get(result, 'paymentIntent.status')
      if (status === 'succeeded') {
        this.card.clear()
        this.$emit('payment-succeeded', get(result, 'paymentIntent', {}))
      } else {
        this.$emit('payment-failed', result.error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$borderColor: #d8d8d8;

.card {
  border: 1px solid $borderColor;
  border-radius: 4px;
  height: 40px;
}
</style>
